import PropTypes from 'prop-types';
import { Container } from '@/components/ui/Container';
import { Button } from '@/components/ui/Button';
import {
    ContentCard,
    ContentCardHeader,
    ContentCardTitle,
    ContentCardRow,
    DetailLabel,
    DetailSecondaryText,
    KPICardsGrid,
    ProfileStatPill,
    ProfileStatsRow,
    ProfileRoleBadge,
} from '@/pages/inside/tenant/style';
import { EyeOutlined } from '@ant-design/icons';

const ProfileAccessCard = ({
    role,
    planLabel,
    totalModules,
    totalFeatures,
    totalActions,
    onViewPermissions,
}) => (
    <ContentCard $marginBottom="0">
        <ContentCardHeader>
            <ContentCardTitle>Role &amp; permissions</ContentCardTitle>
        </ContentCardHeader>

        <ContentCardRow style={{ flexDirection: 'column', alignItems: 'stretch', gap: 16, borderBottom: 'none' }}>
            <KPICardsGrid $columns={3} $rows={1} $height="auto">
                <Container
                    $padding="14px 16px"
                    $borderRadius="10px"
                    style={{
                        background: 'var(--ant-color-fill-quaternary, #fafafa)',
                        border: '1px solid var(--ant-color-border-secondary, #f0f0f0)',
                    }}
                >
                    <DetailSecondaryText as="div" style={{ fontSize: 12, marginBottom: 4 }}>
                        Modules
                    </DetailSecondaryText>
                    <strong style={{ fontSize: 22 }}>{totalModules}</strong>
                </Container>
                <Container
                    $padding="14px 16px"
                    $borderRadius="10px"
                    style={{
                        background: 'var(--ant-color-fill-quaternary, #fafafa)',
                        border: '1px solid var(--ant-color-border-secondary, #f0f0f0)',
                    }}
                >
                    <DetailSecondaryText as="div" style={{ fontSize: 12, marginBottom: 4 }}>
                        Features
                    </DetailSecondaryText>
                    <strong style={{ fontSize: 22 }}>{totalFeatures}</strong>
                </Container>
                <Container
                    $padding="14px 16px"
                    $borderRadius="10px"
                    style={{
                        background: 'var(--ant-color-fill-quaternary, #fafafa)',
                        border: '1px solid var(--ant-color-border-secondary, #f0f0f0)',
                    }}
                >
                    <DetailSecondaryText as="div" style={{ fontSize: 12, marginBottom: 4 }}>
                        Actions
                    </DetailSecondaryText>
                    <strong style={{ fontSize: 22 }}>{totalActions}</strong>
                </Container>
            </KPICardsGrid>

            <ProfileStatsRow>
                <ProfileRoleBadge>{role}</ProfileRoleBadge>
                <ProfileStatPill>{planLabel} plan</ProfileStatPill>
            </ProfileStatsRow>
        </ContentCardRow>

        <ContentCardRow>
            <Container $flex="1" $minWidth="0" $display="flex" $flexDirection="column" $gap="4px">
                <DetailLabel as="div">Permission overview</DetailLabel>
                <DetailSecondaryText>
                    Access spans {totalModules} modules, {totalFeatures} feature groups, and {totalActions}{' '}
                    actions in this workspace.
                </DetailSecondaryText>
            </Container>
            <Button type="link" $primary={false} $size="14px" onClick={onViewPermissions}>
                <EyeOutlined /> View permissions
            </Button>
        </ContentCardRow>
    </ContentCard>
);

ProfileAccessCard.propTypes = {
    role: PropTypes.string.isRequired,
    planLabel: PropTypes.string.isRequired,
    totalModules: PropTypes.number.isRequired,
    totalFeatures: PropTypes.number.isRequired,
    totalActions: PropTypes.number.isRequired,
    onViewPermissions: PropTypes.func.isRequired,
};

export default ProfileAccessCard;
